import { Box, SelectProps, Tooltip } from "@mui/material"
import { ControlProps, SelectInput, SelectInputProps } from "@sis/react-library"
import { DisabledCriteriaResult } from "./disabledCriteria"

interface ActionBarSelectInputProps {
    disabledCriteriaResult?: DisabledCriteriaResult;
}

const SelectInputControl = ({
    hideBlankSelection, hideFilterSearch, disabled, disabledCriteriaResult, ...props
}: ControlProps & SelectInputProps & SelectProps & ActionBarSelectInputProps) => {

    const isDisabled = disabled || disabledCriteriaResult?.isDisabled;

    return (
        <SelectInput
            variant="outlined"
            size="small"
            hideBlankSelection={hideBlankSelection === undefined}
            hideFilterSearch={hideFilterSearch === undefined}
            disabled={isDisabled}
            {...props}
        />
    )
}

export const ActionBarSelectInput = ({
    disabledCriteriaResult, ...props
}: ControlProps & SelectInputProps & SelectProps & ActionBarSelectInputProps) => {

    const disabledReason = disabledCriteriaResult?.reason;
    const selectInputProps = { disabledCriteriaResult, ...props };

    return (
        <>
            {disabledReason &&
                <Tooltip title={disabledReason} arrow>
                    <Box style={{ marginTop: '-8px' }}><SelectInputControl {...selectInputProps} /></Box>
                </Tooltip>
            }
            {!disabledReason && <SelectInputControl {...selectInputProps} />}
        </>
    )
}
